import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useProducts from '../Admin/useProducts';
import ProductCollection from '../UI/ProductCollection';

/**
 * "Hot products" listing. Used both as a standalone route and as a
 * rail on the landing page — `layout` decides which.
 */
const HotProducts = ({ layout = 'grid', perPage = 4, columns }) => {
  const location = useLocation();

  const filters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      category_code: params.get('category') || '',
      product_guide: params.get('guide') || '',
      price_min: params.get('price_min') || '',
      price_max: params.get('price_max') || '',
      cut: params.get('cut') || '',
      shape: params.get('shape') || '',
      min_price: null,
      max_price: null,
      per_page: perPage,
      hot: params.get('type') || 'hot',
    };
  }, [location.search, perPage]);

  const { products, load, err, fetchproducts } = useProducts(filters);

  return (
    <ProductCollection
      products={products}
      loading={load}
      error={err}
      onRetry={() => fetchproducts(1)}
      layout={layout}
      columns={columns}
      limit={perPage}
      skeletonCount={perPage}
      emptyTitle="No hot products right now"
      emptyMessage="Check back soon — our best sellers are restocked regularly."
    />
  );
};

export default HotProducts;
